module.exports = __webpack_public_path__ + "img/DE00995.620fbc33.png";